"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveOurShip = void 0;
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var DiscardCards_1 = require("../../../deferredActions/DiscardCards");
var DeferredAction_1 = require("../../../deferredActions/DeferredAction");
var DrawCards_1 = require("../../../deferredActions/DrawCards");
var SaveOurShip = (function (_super) {
    __extends(SaveOurShip, _super);
    function SaveOurShip() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.SAVE_OUR_SHIP,
            cost: 0,
            metadata: {
                cardNumber: 'L419',
                victoryPoints: -1,
                description: 'Discard 2 cards, then draw 3 cards.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.minus().cards(2).br;
                    b.plus().cards(3);
                }),
            },
        }) || this;
    }
    SaveOurShip.prototype.canPlay = function (player) {
        return _super.prototype.canPlay.call(this, player) && player.cardsInHand.length > 2;
    };
    SaveOurShip.prototype.getVictoryPoints = function () {
        return -1;
    };
    SaveOurShip.prototype.play = function (player) {
        player.game.defer(new DiscardCards_1.DiscardCards(player, this.name, 2), DeferredAction_1.Priority.DISCARD_BEFORE_DRAW);
        player.game.defer(DrawCards_1.DrawCards.keepAll(player, 3));
        return undefined;
    };
    return SaveOurShip;
}(Card_1.Card));
exports.SaveOurShip = SaveOurShip;
//# sourceMappingURL=SaveOurShip.js.map